var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ width: _vm.w, height: _vm.h }),on:{"touchmove":function($event){$event.preventDefault();}}},[_c('canvas',{staticClass:"canvas",attrs:{"id":_vm.uid,"data-uid":_vm.uid,"disabled":_vm.disabled}})])
}
var staticRenderFns = []

export { render, staticRenderFns }